<template>
    <rkm-overlay>
        <rkm-layout-body :title="`${id ? 'Edição' : 'Cadastro'} de gestor`">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit()"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @save="handleSave()"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/administracao/gestor/Form'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {Form},
    created() {
        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {
            this.showExitConfirmation(async () => {
                this.unsetShowExitFormConfirmation()
                this.redirectToList()
            })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {
            this.$router.push({name: 'administracao-gestor-index'})
        },
    },
    props: {
        id: {type: Number, default: null}
    },
}
</script>